enum AuthTypesEnum {
  SMARTSELL = 'smartsell',
  MICROSOFT = 'microsoft_oauth2',
}

export default AuthTypesEnum;
